import type { Size } from '@studio/design-system/button';
import { Button } from '@studio/design-system/button';
import { Icon } from '@studio/design-system/icon';
import { toObjectEntries } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { Column, Exhibit } from './styled.jsx';

/* eslint-disable sort-keys-fix/sort-keys-fix */
const Sizes: Record<Size, string> = {
  sm: 'Small',
  md: 'Medium',
  lg: 'Large',
  xl: 'Extra Large'
};
/* eslint-enable sort-keys-fix/sort-keys-fix */

/** `<Buttons>` exhibit. */
export const Buttons = (): ReactElement => (
  <Exhibit title='Buttons'>
    <Column className='items-start gap-40 bg-transparent'>
      {toObjectEntries(Sizes).map(([size, name]) => (
        <div className='flex flex-col items-start gap-16' key={size}>
          <Button size={size}>Primary {name} Button</Button>

          <Button size={size}>
            <Icon icon='alert-circle' /> Primary {name} Button with Icon
          </Button>

          <Button disabled size={size}>
            Primary {name} Disabled Button
          </Button>

          <Button size={size} variant='secondary'>
            Secondary {name} Button
          </Button>

          <Button size={size} variant='secondary'>
            <Icon icon='alert-circle' /> Secondary {name} Button with Icon
          </Button>

          <Button disabled size={size} variant='secondary'>
            Secondary {name} Disabled Button
          </Button>

          <Button size={size} variant='tertiary'>
            Tertiary {name} Button
          </Button>

          <Button size={size} variant='tertiary'>
            <Icon icon='preset-image' /> Tertiary {name} Button with Icon
          </Button>
        </div>
      ))}
    </Column>
  </Exhibit>
);
